








































import { defineComponent, PropType, computed } from '@vue/composition-api';
import { isEmpty, debounce } from 'lodash-es';
import AdgroupLevelNode from './sidebar-node/adgroup-level-node.vue';
import LevelNode from './sidebar-node/level-node.vue';
import CampaignNode from './sidebar-node/campaign-node.vue';
import { CampaignItem, AdgroupItem, AdItem, CreationLevel } from './types';

const DEBOUNCE_WAIT_TIME = 500;
const name = 'ttam-creation-sidebar';

export default defineComponent({
  name,
  components: {
    CampaignNode,
    AdgroupLevelNode,
    LevelNode,
  },
  props: {
    curUid: {
      type: String,
      required: true,
    },
    isSplitTestOpen: {
      type: Boolean,
      default: false,
    },
    curLevel: {
      type: String as PropType<CreationLevel>,
      default: 'campaign',
    },
    campaignInfo: {
      type: Object as PropType<CampaignItem>,
      required: true,
    },
    adgroupInfos: {
      type: Array as PropType<AdgroupItem[]>,
      default: () => [],
    },
    splitTestInfo: {
      type: Object as PropType<AdgroupItem>,
      default: () => ({}),
    },
    adInfo: {
      type: Array as PropType<AdItem[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const adgroupLevelInfos = computed(() => {
      if (isEmpty(props.splitTestInfo)) {
        return props.adgroupInfos;
      }
      return props.adgroupInfos.concat(props.splitTestInfo);
    });
    function handleSwitch(level: CreationLevel, uid: string) {
      console.log('==== switch ====', level, uid);
      emit('switch', level, uid);
    }

    function handleActionTrigger(level: CreationLevel, eventName: string, uids) {
      console.log('==== action ====', level, eventName, uids);
      emit('action', level, eventName, uids);
    }

    function handleAdgroupExpand(adgroupUuid: string, status: boolean) {
      console.log('==== expand-adgroup ====', adgroupUuid, status);
      emit('expand-adgroup', adgroupUuid, status);
    }

    function goToListPage(level, uuid: string) {
      emit('goToListPage', level, uuid);
    }

    // 在点击的时候执行一次，DEBOUNCE_WAIT_TIME时间内点击不在执行
    const debounceHandleActionTrigger = debounce(handleActionTrigger, DEBOUNCE_WAIT_TIME, {
      leading: true,
      trailing: false,
    });
    const debounceHandleSwitch = debounce(handleSwitch, DEBOUNCE_WAIT_TIME, { leading: true, trailing: false });

    return {
      name,
      adgroupLevelInfos,
      debounceHandleActionTrigger,
      debounceHandleSwitch,
      handleAdgroupExpand,
      goToListPage,
    };
  },
});
